import auditTab from './auditTab';

export default [
  auditTab,
];
